export default (filterTypes, value) => {
  const filter = filterTypes.filter((filter) => (filter.value.toString() === value.toString()))[0]
  return filter
}
